import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaTimes, FaPhone } from "react-icons/fa";
import { MdOutlineClose } from "react-icons/md";
import "../style.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [logoError, setLogoError] = useState(false);

  const navItems = [
    { label: "Home", path: "/home" },
    { label: "About Us", path: "/about" },
    { label: "Sightseeing", path: "/sightseeing" },
    { label: "Airport Transfer", path: "/airport-transfer" },
    { label: "Outstation", path: "/outstation" },
    { label: "Package", path: "/packages" },
    { label: "Book Cab", path: "/book-cab" },
    { label: "Gallery", path: "/gallery" },
    { label: "ContactUs", path: "/contact-us"}
  
  ];

  /* Scroll effect */
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* Logo check */
  useEffect(() => {
    fetch("/logo.png")
      .then(res => !res.ok && setLogoError(true))
      .catch(() => setLogoError(true));
  }, []);

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="nav-container">

        {/* Logo */}
        <div className="nav-logo">
          {logoError ? (
            <div className="logo-text">
              <span className="logo-part-blue">Cab</span>
              <span className="logo-part-orange">Express</span>
            </div>
          ) : (
            <img
              src="/logo.png"
              alt="Cab Express Logo"
              className="logo-image"
              onError={() => setLogoError(true)}
            />
          )}
        </div>

        {/* Desktop Navigation */}
        <div className="nav-links">
          {navItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={() => setIsMenuOpen(false)}
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        {/* Right Buttons */}
        <div className="nav-right">
          <NavLink to="/book-now" className="book-now-btn">
            Book Now
          </NavLink>

          <button
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          >
            {isMenuOpen ? (
              <MdOutlineClose className="menu-icon" />
            ) : (
              <FaBars className="menu-icon" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMenuOpen ? "active" : ""}`}>
        <div className="mobile-menu-header">
          <div className="mobile-contact-info">
            <FaPhone className="mobile-phone-icon" />
          </div>

          <button
            className="mobile-close-btn"
            onClick={() => setIsMenuOpen(false)}
          >
            <FaTimes />
          </button>
        </div>

        <div className="mobile-nav-links">
          {navItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              className={({ isActive }) =>
                isActive ? "mobile-link active" : "mobile-link"
              }
              onClick={() => setIsMenuOpen(false)}
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="mobile-book-section">
          <NavLink
            to="/book-cab"
            className="mobile-book-btn"
            onClick={() => setIsMenuOpen(false)}
          >
            Book Now
          </NavLink>
        </div>
      </div>

      {/* Overlay */}
      {isMenuOpen && (
        <div
          className="mobile-overlay"
          onClick={() => setIsMenuOpen(false)}
        />
      )}
    </nav>
  );
};

export default Navbar;
